import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const voucherReportsRoutesDictionary = moduleRouteDictionaryFactory(
  'voucherReports',
  'voucherReports',
  {
    reports: 'reports-monthly',
  },
);
